export const EXSBORDER_SHOW_RESET = 'EXSBORDER_SHOW_RESET'
export const EXSBORDER_SHOW_SET_ERROR = 'EXSBORDER_SHOW_SET_ERROR'
export const EXSBORDER_SHOW_SET_RETRIEVED = 'EXSBORDER_SHOW_SET_RETRIEVED'
export const EXSBORDER_SHOW_TOGGLE_LOADING = 'EXSBORDER_SHOW_TOGGLE_LOADING'
